import { render, staticRenderFns } from "./OdemeBildirimiPopup.vue?vue&type=template&id=b05b7e7a&"
import script from "./OdemeBildirimiPopup.vue?vue&type=script&lang=js&"
export * from "./OdemeBildirimiPopup.vue?vue&type=script&lang=js&"
import style0 from "./OdemeBildirimiPopup.vue?vue&type=style&index=0&id=b05b7e7a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports